import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

import LoginModal from '../LoginModal';

let styles;

const Body = props => (
  <div className={css(styles.body, props.hasFooter && !Theme.isMobile ? styles.footer : false)}>
    { props.children }
    {
      props.loginModalCloseHandler ? (
        <LoginModal open={props.loginModalOpen} closeHandler={props.loginModalCloseHandler} />
      ) : false
    }
  </div>
);

export default Body;

Body.defaultProps = {
  hasFooter: false,
  children: null,
  loginModalOpen: false,
  loginModalCloseHandler: false,
};

Body.propTypes = {
  loginModalOpen: PropTypes.bool,
  hasFooter: PropTypes.bool,
  loginModalCloseHandler: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]),
  children: PropTypes.arrayOf(PropTypes.node),
};

styles = StyleSheet.create({
  body: {
    position: 'relative',
    fontFamily: Theme.font_family_primary,
    backgroundColor: '#f0f0f0',
    minHeight: '100vh',
    overflow: 'hidden',
  },
  footer: {
    paddingBottom: Theme.footer.height,
  },
});



// WEBPACK FOOTER //
// ./src/components/Body/index.js